
import { defineComponent, PropType, computed } from 'vue'
import { imageDefaultProps } from '@smilekite/lego-bricks'
import { v4 as uuidv4 } from 'uuid'
import { message } from 'ant-design-vue'
import StyledUploader from '../components/StyledUploader.vue'
import { ComponentData } from '../store/editor'
import { RespUploadData } from '../store/respTypes'
import { getImageDimensions } from '../helper'
import { TemplateType, BrickComponents, BrickComponentProps } from '@/configs/defaultTemplates'

export default defineComponent({
  name: 'ComponentsList',
  components: {
    StyledUploader
  },
  props: {
    list: {
      type: Array as PropType<BrickComponentProps[]>,
      required: true
    },
    type: {
      type: String as PropType<TemplateType>,
      required: true
    }
  },
  emits: ['on-item-click'],
  setup(props, context) {
    const componentMap: Record<TemplateType, BrickComponents> = {
      [TemplateType.TEXT]: 'l-text',
      [TemplateType.IMAGE]: 'l-image',
      [TemplateType.SHAPE]: 'l-shape'
    }
    const componentName = computed(() => componentMap[props.type as TemplateType])
    const showImageUploader = computed(() => props.type === TemplateType.IMAGE)
    const onItemClick = (props: BrickComponentProps) => {
      const componentData: ComponentData = {
        name: componentName.value as BrickComponents,
        id: uuidv4(),
        props
      }
      context.emit('on-item-click', componentData)
    }
    const onImageUploaded = (data: { resp: RespUploadData; file: File }) => {
      const { resp, file } = data
      const componentData: ComponentData = {
        name: 'l-image',
        id: uuidv4(),
        props: {
          ...imageDefaultProps
        }
      }
      message.success('上传成功')
      componentData.props.src = resp.data.urls[0]
      getImageDimensions(file).then(({ width }) => {
        const maxWidth = 373
        componentData.props.width = (width > maxWidth ? maxWidth : width) + 'px'
        context.emit('on-item-click', componentData)
      })
    }
    return {
      componentName,
      showImageUploader,
      componentMap,
      onItemClick,
      onImageUploaded
    }
  }
})
